// extracted by mini-css-extract-plugin
export default {"circle_divisions":"styles_circle_divisions__YkeNd","circle_divisions_chart":"styles_circle_divisions_chart__xHxD5"};